import { useStyletron } from 'styletron-react'
import { HEADER_HEIGHT } from '@styles/constants'
import Link from 'next/link'
import { LabelS } from '@components/base-typography'
import { colors } from '@styles/colors'
import { BaseButton } from '../base-button'
import { useMe } from '@modules/users/hooks/use-me'
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid'
import { Logo } from '../logo'
import { HeaderMenu } from './header-menu'
import { boxShadow } from '@styles/box-shadow'
import { BaseGrid } from '../base-grid'
import { BaseCell } from '../base-cell'
import { zIndexes } from '@styles/z-indexes'
import { Routes } from '@lib/routes'
import { useScrollPoint } from '@lib/hooks/use-scroll-point'
import { BaseBlock } from '../base-block'
import { BaseDrawer } from './drawer'
import { UserRole } from '@lib/graphql/documents.generated'
import { IconType } from '@components/icon'

type HeaderType = 'loggedOut' | 'doctor' | 'patient'

interface HeaderProps {
  type?: HeaderType
}

export const Header = ({}: HeaderProps) => {
  const [css] = useStyletron()

  const { me, loading } = useMe()
  const isLoggedIn = Boolean(me)

  const { isPoint } = useScrollPoint()

  return (
    <header
      className={css({
        position: 'fixed',
        top: 0,
        width: '100%',
        boxSizing: 'border-box',
        backgroundColor: colors.white,
        zIndex: zIndexes.header,
        ...(isPoint && boxShadow('borderBottom')),
      })}
    >
      <BaseGrid>
        <BaseCell span={[4, 8, 12]}>
          <FlexGrid
            className={css({
              height: HEADER_HEIGHT + 'px',
              display: 'flex',
              alignItems: 'center',
            })}
            gridColumnGap="32px"
            flexGridColumnCount={3}
          >
            <FlexGridItem
              key="logo"
              className={css({
                flex: '1 1 0',
              })}
            >
              <Logo size="s" active />
            </FlexGridItem>
            {!loading && (
              <>
                <FlexGridItem
                  display={['none', 'none', 'block', 'block']}
                  className={css({
                    flex: '1 1 auto',
                  })}
                >
                  {/* <nav
                    className={css({
                      display: 'flex',
                      columnGap: '16px',
                      justifyContent: 'center',
                    })}
                  >
                    {navigations.map(({ label, href }) => (
                      <NavItem
                        key={label}
                        label={label}
                        href={href}
                        selected={pathname.includes(href)}
                      />
                    ))}
                  </nav> */}
                </FlexGridItem>
                <FlexGridItem
                  className={css({
                    flex: '1 1 0',
                    display: 'flex',
                    justifyContent: 'flex-end',
                  })}
                >
                  {!loading && isLoggedIn ? (
                    <>
                      <BaseDrawer />
                      <HeaderMenu
                        menus={[
                          ...((me &&
                            me?.role !== UserRole.Patient && [
                              {
                                name: '해석 참여하기',
                                icon: 'ChevronRight' as IconType,
                                href: Routes.DOCTOR_HOME,
                                onClick: undefined,
                                color: undefined,
                              },
                            ]) ||
                            []),
                          {
                            name: '설정',
                            icon: undefined,
                            href: Routes.SETTINGS_ACCOUNT,
                            onClick: undefined,
                            color: undefined,
                          },
                        ]}
                      />
                    </>
                  ) : (
                    <BaseBlock flexbox columnGap="16px">
                      <Link href={Routes.AUTH_LOGIN} passHref>
                        <BaseButton $type="secondary" $size="m">
                          로그인
                        </BaseButton>
                      </Link>
                      <Link href={Routes.AUTH_LOGIN} passHref>
                        <BaseButton $size="m">회원가입</BaseButton>
                      </Link>
                    </BaseBlock>
                  )}
                </FlexGridItem>
              </>
            )}
          </FlexGrid>
        </BaseCell>
      </BaseGrid>
    </header>
  )
}

const NavItem = ({
  href,
  label,
  selected,
}: {
  href: string
  label: string
  selected: boolean
}) => {
  const [css] = useStyletron()

  return (
    <Link href={href} passHref>
      <LabelS
        as="a"
        weight={500}
        color={selected ? colors.black : colors.gray500}
        // className={css({
        //   position: 'relative',
        //   whiteSpace: 'pre',
        //   ...flexCenter,
        //   ...padding('10px', '16px'),
        //   ...borderRadius(8),
        //   ...transition('background-color', '0.2s'),
        //   ':hover': {
        //     backgroundColor: colors.gray50,
        //   },
        //   ':after': {
        //     content: '""',
        //     display: 'block',
        //     position: 'absolute',
        //     bottom: '0px',
        //     width: '16px',
        //     height: '2px',
        //     backgroundColor: selected ? colors.gray700 : colors.white,
        //     ...borderRadius(4),
        //     ...transition('width', '0.1s'),
        //   },
        // })}
      >
        {label}
      </LabelS>
    </Link>
  )
}
